<template>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-between">
    <div>
      <router-link slot="brand" class="navbar-brand tw-block lg:tw-hidden" to="/">
        <img src='@/assets/barter-full.png' alt='logobarter'>
      </router-link>
      <h1 class="tw-mt-6 tw-text-2xl lg:tw-text-3xl">Password Reset</h1>
      <p class="tw-text-sm">
        Enter your account name and email address below, and we’ll send you a code to reset your password.
      </p>
    </div>

    <form role="form" class="tw-mb-6">
      <tw-base-input id="ref-password-reset-account-name" data-test-id="ref-password-reset-account-name" label="Account Name" placeholder="Enter account name" v-model="model.accountName"/>
      <tw-base-input id="ref-password-reset-email" data-test-id="ref-password-reset-email" label="Email Address" placeholder="Enter email address" v-model="model.email"/>
      
      <div class="tw-flex tw-space-x-2 tw-w-full tw-py-4">
        <tw-base-button
          id="ref-password-reset-submit"
          data-test-id="ref-password-reset-submit"
          type="danger"
          innerClass="tw-p-2"
          size="sm"
          block
          @click.prevent="passwordReset"
          :disabled="loading"
        >
          <a-spin v-if="loading" :spinning="loading"  />
          <div v-else>Reset Password</div>
        </tw-base-button>
      </div>
    </form>

    <footer class="tw-text-center tw-text-xs tw-mt-6">
      <a id="ref-password-reset-login" data-test-id="ref-password-reset-login" href="/login" class="tw-text-blue-600">Login to your account</a>
    </footer>
  </div>
</template>
<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['endPoint']),
  },
  name: 'register',
  data() {
    return {
      model: {
        email: '',
        accountName: '',
      },
      loading: false,
      notification: {},
      errorMessage: null,
      successMessage: null
    }
  },
  methods: {
    backTologin(){
      this.$router.go(-1)
    },
    async passwordReset(){
      this.$emit('changeAuthLayoutSpinning', true);
      this.loading = true;
      this.notification = {};

      if (this.model.email.trim() == '' || this.model.accountName.trim() == '') {
        this.notification.message = "Your account name and email are both required fields for login. Please try again."
        this.notification.type = "danger"
        this.notification.icon = "fa-circle-xmark"
        this.loading = false;
      } else {
        const passwordResetPayload = { email: this.model.email, account_name: this.model.accountName }
        const post_request = await HTTPRequest.postRequest(this.endPoint + 'users/reset_password', null, passwordResetPayload) 
        
        if(post_request["success"] == undefined){
          this.notification.message = post_request["error"];
          this.notification.type = "danger"
          this.notification.icon = "fa-circle-xmark"
        } else {
          this.model.email = '';
          this.model.account = '';
          this.successMessage = `Password reset code was sent to your email address ${this.model.email}`
          this.notification.message = post_request['success'];
          this.notification.type = "success";
          this.notification.icon = "fa-circle-check";
        }
      }
      this.loading = false;
      this.$emit("handleNotifications", this.notification);
      this.$emit('changeAuthLayoutSpinning', false);
    }
  }
}
</script>
